export const getNotificationPrefix = (authState = {}) => {
  const { employeeLogin, organisationLogin } = authState;

  if (employeeLogin) return "emp";
  if (organisationLogin) return "client";

  return "client";
};

export const extractNotificationCount = (response) => {
  if (!response) return 0;

  if (typeof response === "number") return response;

  if (typeof response?.data === "number") return response.data;
  if (typeof response?.count === "number") return response.count;
  if (typeof response?.unreadCount === "number") return response.unreadCount;

  if (typeof response?.data?.count === "number") return response.data.count;
  if (typeof response?.data?.unreadCount === "number") {
    return response.data.unreadCount;
  }
  if (typeof response?.data?.totalUnread === "number") {
    return response.data.totalUnread;
  }

  return 0;
};

export const isNotificationRead = (notification = {}) => {
  if (typeof notification.isRead === "boolean") return notification.isRead;
  if (typeof notification.read === "boolean") return notification.read;
  if (typeof notification.is_read === "boolean") return notification.is_read;
  if (typeof notification.seen === "boolean") return notification.seen;

  const status = String(
    notification.status ?? notification.readStatus ?? notification.state ?? "",
  )
    .trim()
    .toLowerCase();

  if (!status) return false;

  return ["read", "seen", "resolved", "closed", "done", "completed"].includes(
    status,
  );
};
